<template>
    <form @submit.prevent="onSubmit()" @keydown="form.$errors.clear($event.target.name);">
        <div class="card card-form">
            <div class="row no-gutters">
                <div class="col-xl-3 p-3">
                    <div class="row">
                        <div class="col-xl-12 col-sm-6">
                            <b-form-group :label="$t('[[[Nazwa roli]]]')" :feedback="form.$errors.first('roleName')" :state="form.$errors.state('roleName')" v-required>
                                <b-form-input v-model="form.roleName" type="text" name="roleName" v-focus></b-form-input>
                            </b-form-group>
                            <b-form-group>
                                <b-form-checkbox v-model="form.isActive">{{ $t('[[[Rola aktywna]]]') }}</b-form-checkbox>
                            </b-form-group>
                        </div>
                    </div>
                </div>
                <div class="col-xl-9 p-3 bg-light">
                    <b-form-group :label="$t('[[[Uprawnienia]]]')">
                        <permissions v-model="form.permissions"></permissions>
                    </b-form-group>
                </div>
            </div>
            <!-- Przyciski -->
            <div class="card-footer">
                <responsive>
                    <button type="submit" class="btn btn-primary" :disabled="form.disabled() || !form.meta.canEdit">
                        <i class="fas fa-check"></i> {{ $t('[[[Zapisz]]]') }}
                    </button>
                    <button type="button" class="btn btn-secondary" @click="onSubmit('core-roles')" :disabled="form.disabled() || !form.meta.canEdit">
                        <i class="far fa-check-circle"></i> {{ $t('[[[Zapisz i wróć]]]') }}
                    </button>
                    <router-link class="btn btn-light" :to="{name:'core-roles'}">
                        <i class="far fa-arrow-alt-circle-left"></i> {{ $t('[[[Powrót]]]') }}
                    </router-link>
                </responsive>
            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/helpers/Form';
import Permissions from '@/components/security/Permissions';
import RolesService from '@/services/core/RolesService';

export default
{
    components: {
        permissions: Permissions
    },

    data: function()
    {
        return {
            form: Form.create({
                id: 0,
                roleName: '',
                permissions: [],
                meta: {
                    canEdit: true
                }
            })
        };
    },

    created: function()
    {
        if (this.id)
        {
            this.loadData(this.id);
        }
    },

    computed: {
        id()
        {
            return this.$route.params.id;
        }
    },

    methods: {
        async loadData(id)
        {
            try
            {
                let response = await RolesService.fetch(id);
                this.form.withData(response.data);
            }
            catch (ex)
            {
                this.form.disable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        async onSubmit(route = 'core-roles-edit')
        {
            try
            {
                this.form.disable();

                if (!this.id)
                {
                    let result = await RolesService.create(this.form.data());
                    this.$alert.success(this.$t('[[[Rola została dodana.]]]'));
                    this.form.withData(result.data);
                }
                else
                {
                    await RolesService.update(this.id, this.form.data());
                    this.$alert.success(this.$t('[[[Rola została zaktualizowana.]]]'));
                }

                this.$router.push({ name: route, params: { id: this.form.id } });
                this.form.enable();
            }
            catch (ex)
            {
                this.form.enable();

                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                if (ex.code === 422)
                    this.form.$errors.record(ex.data.errors);

                this.$log.debug(ex);
            }
        }
    }
};
</script>
